export default __webpack_public_path__ + "static/media/close-square-o.b0c5929a.svg";